'use_strict';

/**
 * Animations for location prompt
 */
const animations = {
  slideUp(el, delay) {
    el.style.display = '';
    const animation = el.animate({ transform: ['translateY(0%)', 'translateY(-100%)'] }, delay || 200);
    animation.onfinish = () => {
      el.style.display = 'none';
    };
    return animation;
  },

  slideDown(el, delay) {
    const animation = el.animate({ transform: ['translateY(-100%)', 'translateY(0px)'] }, delay || 200);
    return animation;
  },
};

// SVG icon for location prompt, remember to change this if the icon changes
const SVG = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4899 21C4.71141 21 0 16.2886 0 10.4899C0 4.69127 4.71141 0 10.4899 0C16.2685 0 20.9799 4.71141 20.9799 10.4899C20.9799 16.2685 16.2886 21 10.4899 21ZM10.4899 1.81208C5.71812 1.81208 1.81208 5.71812 1.81208 10.4899C1.81208 15.2617 5.71812 19.1678 10.4899 19.1678C15.2819 19.1678 19.1678 15.2617 19.1678 10.4899C19.1678 5.71812 15.2819 1.81208 10.4899 1.81208Z" fill="#262626"/>
              <path d="M9.604 8.37582H11.4564V14.6376H9.604V8.37582Z" fill="#262626"/>
              <path d="M11.9395 14.7986H9.06034C8.75833 14.7986 8.49658 14.557 8.49658 14.2349C8.49658 13.9127 8.75833 13.6913 9.06034 13.6913H11.9194C12.2214 13.6913 12.4832 13.9329 12.4832 14.255C12.4832 14.5772 12.2415 14.7986 11.9395 14.7986Z" fill="#262626"/>
              <path d="M10.4898 7.61072C11.1348 7.61072 11.65767.08788 11.6576 6.44293C11.6576 5.79798 11.1348 5.27515 10.4898 5.27515C9.84486 5.27515 9.32202 5.79798 9.32202 6.44293C9.32202 7.08788 9.84486 7.61072 10.4898 7.61072Z" fill="#51B848"/>
            </svg>`;

/**
 * Partition function. Divides array into two based on a filter function.
 *
 * @param {array} array - Array to divide
 * @param {function} filter - Filtering function
 *
 * @returns {array<array>}
 */
function partition(array, filter) {
  let pass = [], fail = [];
  array.forEach((e, idx, arr) => (filter(e, idx, arr) ? pass : fail).push(e));
  return [pass, fail];
}

let locationPrompts = {

  /**
   * Redirect to another page
   * @param {string} address - url to redirect to
   * @param {boolean} matchPage - Check if current page exists in target site language. Otherwise redirects to target url in db (usually homepage).
   *
   * @returns {void}
   */
  redirect: function (address, matchPage = false) {
    let targetAddress = address;

    if(matchPage) {
      const targetAddressHost = new URL(address).host;
      const langVersionUrls = Array.from(document.querySelectorAll('link[rel="alternate"]')).map(el => el.href);
      const matchedPageUrl = langVersionUrls.find(url => new URL(url).host === targetAddressHost);

      if(matchedPageUrl) {
        targetAddress = matchedPageUrl;
      }

      // NTCONT-1396: No redirect on news article page.
      if(document.location.pathname.indexOf('/about-us/news-article/') === 0) {
        return;
      }
    }

    document.location.replace(targetAddress);
  },

  /**
   * Hide the prompt
   * @param {boolean} chosenValue - true or false
   * @param {object} rule - Object with prompt data
   *
   * @returns {void}
   */
  hideCountryPrompt: function (chosenValue, rule) {
    let locationPrompt = document.getElementById('locationPrompt');
    document.querySelector(':root').classList.toggle('locationPromptOpen', false);
    animations.slideUp(locationPrompt);
    locationPrompt.setAttribute('aria-hidden', 'true');
    if (window.sessionStorage) {
      sessionStorage.setItem('prompt_' + rule.uuid, chosenValue);
    }
    if (chosenValue) locationPrompts.redirect(rule.redirection_target);

  },

  /**
   * Show the prompt
   * @param {object} rule - Object with prompt data
   *
   * @returns {void}
   */
  showCountryPrompt: function (rule) {

    let locationPrompt = document.getElementById('locationPrompt');

    if (!locationPrompt) {

      locationPrompt = locationPrompts.createPromptElement(rule)

      locationPrompt.setAttribute('aria-hidden', 'true');

      document.body.insertBefore(locationPrompt, document.body.firstChild);

      document.querySelector('a.yes').addEventListener('click', function (e) {
        e.preventDefault();

        /* send analytics event for clicking the prompt for redirect */
        locationPrompts.sendToAnalytics('geo_redirect_click', rule.redirection_target);

        locationPrompts.hideCountryPrompt(true, rule);

      });

      document.querySelector('a.no').addEventListener('click', function (e) {
        e.preventDefault();
        locationPrompts.hideCountryPrompt(false, rule);
      });

      document.querySelector(':root').classList.toggle('locationPromptOpen', true);

      locationPrompt.classList.toggle('locationPromptOpen', true);
      locationPrompt.setAttribute('aria-hidden', 'false');
      animations.slideDown(locationPrompt);
    }

  },

  /**
   * Send event to Google Analytics
   * @param {string} eventName - name of the event
   * @param {string} target - target url
  */
  sendToAnalytics: function (eventName, target) {

    if(window.location.host.indexOf('stage.crasman.fi') < 0){
      window.dataLayer = window.dataLayer || [];// Not in admin > Push event to dataLayer
      window.dataLayer.push({
        'event': eventName,
        'geo_from': window.location.origin,
        'geo_to': target
      });
    }

  },

  /**
   * Create a div with id locationPrompt
   * add svg icon, text and buttons
   * @param {object} rule - Object with prompt data
   * @returns {object} - locationPrompt element
   */
  createPromptElement: function (rule) {
    let locationPrompt = document.createElement('div');
    locationPrompt.setAttribute('id', 'locationPrompt');
    locationPrompt.innerHTML = SVG + '<span class="text">' + rule.question + '</span> <span class="btnWrap"><a class="button green yes" href="' + rule.redirection_target + '">' + rule.yes_text + '</a> <a class="button green no" href="#">' + rule.no_text + '</a></span>';
    return locationPrompt
  },

  /**
   * @typedef {Object} Location
   * @property {string} countryCode - 2-letter country code. ISO 3166-1. Required.
   * @property {string} [subdivisionCode] - 1-3 character subdivision code. ISO 3166-2
   */


  /**
   * Check if there are any redirection rules that apply to the user
   * @param {Location} location - user's detected location
   * @returns {void}
   */
  checkRules: function (location = {}) {
    const rules = window.location_prompts.rules || false;

    if(typeof location !== 'object' || !location.countryCode) {
      return;
    }

    if(Array.isArray(rules)) {
      // Format legacy rules to new format
      // TODO: Remove this when all rules are updated in db
      rules.forEach(rule => {
        if(rule.rule === 'inside') {
          rule.rule = 'inside_country';
        } else if(rule.rule === 'outside') {
          rule.rule = 'outside_country';
        }
      });

      const [automaticRules, promptRules] = partition(rules, rule => rule.automatic_redirect === true);

      // Check automatic redirects first
      // They are not active in admin & editor views, unless testing with ?runRedirects=1 queryparam
      const isAdmin = document.body.classList.contains('adminView');
      const urlParams = new URLSearchParams(window.location.search);
      const testParam = urlParams.get('runRedirects');

      if(!isAdmin || (isAdmin && testParam)) {
        for(const rule of automaticRules) {
          const countryCodes = rule.location_codes ? rule.location_codes.split(',') : [];
          const subdivisionCodes = rule.subdivision_codes ? rule.subdivision_codes.split(',') : [];

          // Do redirect only once. Has this redirect been performed before during this session?
          const item = window.sessionStorage ? sessionStorage.getItem('prompt_auto_' + rule.uuid) : false;

          if(!item) {
            if(rule.rule === 'inside_country_inside_subdivision') {
              if(countryCodes.length === 0 || subdivisionCodes.length === 0) {
                // Invalid rule, cannot match both if both not set. Skip this rule.
                console.log('[LocationPrompts] Skipping invalid rule: ' + rule.uuid);
                continue;
              }

              if(countryCodes.includes(location.countryCode) && subdivisionCodes.includes(location.subdivisionCode)) {
                // Match, redirect
                if(window.sessionStorage) {
                  sessionStorage.setItem('prompt_auto_' + rule.uuid, true);
                }
                locationPrompts.redirect(rule.redirection_target, true);
                return;
              }
            } else if(rule.rule === 'inside_country_outside_subdivision') {
              if(countryCodes.length === 0 || subdivisionCodes.length === 0) {
                // Invalid rule, cannot match both if both not set. Skip this rule.
                console.log('[LocationPrompts] Skipping invalid rule: ' + rule.uuid);
                continue;
              }

              if(countryCodes.includes(location.countryCode) && !subdivisionCodes.includes(location.subdivisionCode)) {
                // Match, redirect
                if(window.sessionStorage) {
                  sessionStorage.setItem('prompt_auto_' + rule.uuid, true);
                }
                locationPrompts.redirect(rule.redirection_target, true);
                return;
              }
            } else if(rule.rule === 'inside_country') {
              if(countryCodes.includes(location.countryCode)) {
                if(window.sessionStorage) {
                  sessionStorage.setItem('prompt_auto_' + rule.uuid, true);
                }
                locationPrompts.redirect(rule.redirection_target, true);
                return;
              }
            } else if(rule.rule === 'outside_country') {
              if(!countryCodes.includes(location.countryCode)) {
                if(window.sessionStorage) {
                  sessionStorage.setItem('prompt_auto_' + rule.uuid, true);
                }
                locationPrompts.redirect(rule.redirection_target, true);
                return;
              }
            }
          }
        }
      }

      // Normal prompts for other rules
      for (let i = 0; i < promptRules.length; i++) {
        const rule = rules[i];
        const location_codes = rule.location_codes ? rule.location_codes.split(',') : null;

        // /* has this prompt been answered? */
        const item = window.sessionStorage ? sessionStorage.getItem('prompt_' + rule.uuid) : false; /* if sessionstorage is available, but item was not found, item becomes null */

        // /* inside */
        if (!item && location_codes && rule.rule === 'inside_country' && location_codes.indexOf(location.countryCode) !== -1) {

          setTimeout(function () {
            locationPrompts.showCountryPrompt(rule);

            /* send analytics event for showing the prompt */
            locationPrompts.sendToAnalytics('geo_redirect_impression', rule.redirection_target);
          }, 1000);
        }
        // /* outside */
        else if (!item && location_codes && rule.rule === 'outside_country' && location_codes.indexOf(location.countryCode) === -1) {
          setTimeout(function () {
            locationPrompts.showCountryPrompt(rule);

            /* send analytics event for showing the prompt */
            locationPrompts.sendToAnalytics('geo_redirect_impression', rule.redirection_target);
          }, 1000);
        }
      }
    }



  },


  /**
   * Initialize location prompts
   * @returns {void}
   */
  init: function () {
    // Check if there any redirection rules in page source
    if(!window.location_prompts) {
      return false; // no rules no worry
    }

    if(!window.sessionStorage) {
      return false; // no sessionstorage, no worry
    }

    // Get user's location from session storage.
    const userLocation = window.sessionStorage ? sessionStorage.getItem('user_location') : false;

    if(!userLocation) {
      const currentLanguage = document.body.getAttribute('data-language');

      /* fetch country code from server */
      fetch(`/stage-ajax/getCountryAndIP?currentLanguage=${currentLanguage}`, {
        method: 'get',
        cache: 'no-cache',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          // Store response to session storage. We don't want to query location service every time.
          sessionStorage.setItem('user_location', JSON.stringify(data));
          // At least countrycode must exist. Others optional.
          if(data?.countryCode) {
            locationPrompts.checkRules(data);
          }
        })
        .catch(function (error) {
          console.error(error);
        });

    }
    else if (userLocation) {
      let userLocationData;
      try {
        userLocationData = JSON.parse(userLocation);
      } catch(e) {
        userLocationData = false;
      }
      locationPrompts.checkRules(userLocationData);
    }
  }
};

export default locationPrompts;
